import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import LightSpeed from "react-reveal/LightSpeed";

import Jello from "react-reveal/Jello";
import axios from "axios";

function Specifiche() {
  let history = useHistory();
  let { modello } = useParams();

  const [veicoli, setVeicoli] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://website-8bit-motors.herokuapp.com/veicoli/specifiche/${modello}`
      )
      .then((response) => {
        setVeicoli(response.data);
      });
  }, []);

  return (
    <Container fluid className="app">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      <h2 style={{ marginBottom: "30px", marginTop: "20px" }} align="center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-list-check"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
          />
        </svg>{" "}
        <strong>Specifiche</strong>
      </h2>

      <Container>
        <Row>
          {veicoli.map((value, key) => {
            return (
              <>
                <Row
                  key={key}
                  className="justify-content-md-center text-center mt-3"
                >
                  <Col style={{ marginLeft: "50px" }}>
                    <LightSpeed left>
                      <Image
                        className="d-block w-100"
                        style={{
                          borderRadius: "40px",
                          border: "1px black solid",
                        }}
                        src={value.url}
                        width="500"
                      />
                      <br />
                    </LightSpeed>
                  </Col>

                  <Col style={{ marginRight: "50px" }}>
                    <LightSpeed right>
                      <Container>
                        <h2>{value.modello}</h2>
                        <strong> Immatricolazione: </strong>{" "}
                        {value.immatricolazione.slice(0, 10)}
                        <br />
                        <strong> Cilindrata: </strong> {value.cilindrata}
                        <br />
                        <strong> Numero Posti: </strong> {value.numero_posti}
                        <br />
                        <strong> Tariffa: </strong>
                        {value.tariffa} € <br /> <br />
                        <Button
                          variant="dark"
                          onClick={() => {
                            history.push(`/veicoli/${value.modello}/noleggia`);
                          }}
                        >
                          {" "}
                          Noleggia
                        </Button>
                      </Container>
                    </LightSpeed>
                  </Col>
                </Row>
              </>
            );
          })}
        </Row>
      </Container>
    </Container>
  );
}

export default Specifiche;
